module.exports = __webpack_public_path__ + "media/images/email/instagram2x-e09d051e1929f17abc9e268e5f54f474.png";